export const stringSplitter = '¦';
